import * as React from 'react';
import * as styles from '../support.module.scss';
import useSupport from '../../../hooks/useSupport';
import { SupportContext } from '../../../shared/support-context';
import FilterType from '../../../models/enums/filterType';
import { Checkbox } from '@material-ui/core';

interface Props {
  filterType: string;
  label?: string;
  allChecked?: boolean;
  setAllChecked?: (check: boolean) => void;
}

/**
 * Filter
 * @function Filter - Individual filter checkbox
 */
const Filter = ({ filterType, label, allChecked, setAllChecked }: Props) => {
  const { updateLocalFilters } = useSupport();
  const { localSelectedFilters } = React.useContext(SupportContext);

  /**
   * @function isChecked - Returns boolean indicating that the checkbox should be checked
   */
  const isChecked = () => {
    switch (filterType) {
      case FilterType.Organization:
        return !!localSelectedFilters.organizationSelected.find(filter => filter === label);
      case FilterType.Requester:
        return !!localSelectedFilters.requesterSelected.find(filter => filter === label);
      case FilterType.Status:
        return !!localSelectedFilters.statusSelected.find(filter => filter === label);
      case FilterType.Type:
        return !!localSelectedFilters.requestTypeSelected.find(filter => filter.text === label || filter === label);
    }
  };

  /**
   * @function chooseStyle - Chooses which classes should be applied to the checkbox
   */
  const chooseStyle = () => {
    if ((!label && allChecked) || (label && isChecked())) {
      return styles.checkboxActive;
    }
    return styles.checkbox;
  };

  return (
    <Checkbox
      checked={label ? isChecked() : allChecked}
      classes={{ root: chooseStyle() }}
      onChange={() => {
        !label && setAllChecked(!allChecked);
        updateLocalFilters(filterType, label, label ? isChecked() : allChecked);
      }}
    />
  );
};

export default Filter;
